import { billingDataForGiftsEnabled } from 'reactApp/appHelpers/featuresHelpers/features/billingDataEndpoint';
import {
    billingDataFailure,
    getBillingDataRequest,
    getBillingDataSuccess,
    updateBillingDataRequest,
} from 'reactApp/modules/billingData/billingData.module';
import { BillingDataReceivedGiftsSelectors } from 'reactApp/modules/billingData/billingData.receivedGifts.selectors';
import type { RootState } from 'reactApp/store';
import { race, select, take } from 'redux-saga/effects';

import { updateReceivedGifts } from './actions/update.action';
import { loadReceivedGiftsAction } from './giftReceived.actions';
import { ReceivedGiftsFetch } from './giftReceived.constants';
import {
    getDiscountGiftByProductId,
    getDiscountGiftList,
    getRawGiftsList,
    getReceivedGiftsLoadingState,
    hasAutoupload10TbGift,
    sortReceivedGiftsByStart,
} from './giftReceived.selectors';

export const loadReceivedGiftsActionFallback = () => (dispatch) => {
    if (billingDataForGiftsEnabled) {
        dispatch(getBillingDataRequest({ radar: 'giftreceived' }));
    } else {
        dispatch(loadReceivedGiftsAction());
    }
};

export function* handleFinishReceivedGiftsFallback() {
    const { isLoaded, isLoading } = yield select(GiftReceivedSelectors.getReceivedGiftsLoadingState);
    if (!isLoaded || isLoading) {
        if (billingDataForGiftsEnabled) {
            yield race({
                success: take(getBillingDataSuccess.toString()),
                fail: take(billingDataFailure.toString()),
            });
        } else {
            yield race({
                success: take(ReceivedGiftsFetch.SUCCESS),
                fail: take(ReceivedGiftsFetch.FAILURE),
            });
        }
    }
}

export const updateReceivedGiftsActionFallback = () => (dispatch) => {
    if (billingDataForGiftsEnabled) {
        dispatch(updateBillingDataRequest({ showSnackbar: false, radar: 'giftreceived', trackFields: ['gift_received'] }));
    } else {
        dispatch(updateReceivedGifts());
    }
};

export const GiftReceivedSelectors = {
    /**  @deprecated: учитывать, что формат разный, к использованию не рекомендуется до выпила старой ручки */
    getRawGiftsList: (!billingDataForGiftsEnabled ? getRawGiftsList : BillingDataReceivedGiftsSelectors.getRawGiftsList) as (
        state: RootState
    ) => unknown[],
    sortReceivedGiftsByStart: !billingDataForGiftsEnabled
        ? sortReceivedGiftsByStart
        : BillingDataReceivedGiftsSelectors.sortReceivedGiftsByStart,
    getDiscountGiftList: !billingDataForGiftsEnabled ? getDiscountGiftList : BillingDataReceivedGiftsSelectors.getDiscountGiftList,
    getDiscountGiftByProductId: !billingDataForGiftsEnabled
        ? getDiscountGiftByProductId
        : BillingDataReceivedGiftsSelectors.getDiscountGiftByProductId,
    getReceivedGiftsLoadingState: !billingDataForGiftsEnabled
        ? getReceivedGiftsLoadingState
        : BillingDataReceivedGiftsSelectors.getReceivedGiftsLoadingState,
    hasAutoupload10TbGift: !billingDataForGiftsEnabled ? hasAutoupload10TbGift : BillingDataReceivedGiftsSelectors.hasAutoupload10TbGift,
} as const;
